import { createSelector } from '@reduxjs/toolkit';

import { DEFAULT_FILTERS_KEYS_MAP } from '@/constants/filters';

import configSelector from './config';

const modelsFilterKeySelector = createSelector(
  configSelector,
  config => config.models?.filterKey || DEFAULT_FILTERS_KEYS_MAP.MODEL,
);

export default modelsFilterKeySelector;
